import React, { useEffect, useState } from 'react';
//*MUI
import { Box, Modal } from '@mui/material';
//*files
import cssClasses from "./GstPercentageChange.module.css"
import Button from '../../../../Subcomponents/Button';
import Close from '../../../Icons/Close';
import DropDown from '../../../../Subcomponents/DropDown';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '35%',
  height: 'fit-Content',
  bgcolor: 'background.paper',
  borderRadius: '8px',
  boxShadow: 24,
};

function GstPercentageChange({ open, handleClose, allotment, sdrPercentage, setApproveConfirmationAlertToggle, newBspPrice, legalCharges, registrationCharges, handleSubmit }) {
  const updatedUnitCost = allotment?.new_unit_cost ? allotment?.new_unit_cost : allotment?.old_unit_cost;
  const [newGst, setNewGst] = useState(Number((allotment?.new_unit_cost?.bsp === "") ? allotment?.unitcost?.bsp : allotment.new_unit_cost?.bsp) < 4500000 ? 1 : 5)

  useEffect(() => {
    calculateNewGst();
  }, [newGst])

  function calculateNewGst() {
    // return Math.round((Number(updatedUnitCost?.bsp) * newGst) / 100);
    return Math.round((Number(newBspPrice) * newGst) / 100);
  }

  function calculateGst() {
    return Math.round(
      Number(newBspPrice) < 4500000
        ? Number(newBspPrice) / 100
        : (Number(newBspPrice) * 5) / 100
    );
  }

  function calculateSdr() {
    return ((Math.ceil((Math.round((Number(newBspPrice) * (sdrPercentage)) / 100)) / 100) * 100) +
      (Number(newBspPrice) > 3000000
        ? (Math.ceil(Number(registrationCharges / 100) * 100))
        : (Math.ceil(Number(newBspPrice / 100) / 100) * 100)) +
      legalCharges);
  }

  return (
    <>
      <Modal
        open={open}
        onClose={() => {
          handleClose();
        }}
        aria-labelledby='modal-modal-title'
        aria-describedby='modal-modal-description'
      >
        <Box sx={style}>
          <Box className={cssClasses.headerDiv}>
            <Box className={cssClasses.flexRow}>
              <Box className={cssClasses.flexCol}>
                <Box className={cssClasses.flexRow}>
                  <Box className={cssClasses.HeaderTitle}>Summary</Box>
                </Box>
              </Box>
              <Box ml={'auto'} mt={1} onClick={handleClose} style={{ cursor: "pointer" }}>
                <Close width={'1.2rem'} height={'1.2rem'} />
              </Box>
            </Box>
          </Box>

          <Box className={cssClasses.DropDownContainer}>
            <Box className={cssClasses.HeaderTitle}>
              Select GST % <sup style={{ color: "red", fontSize: "1.2rem" }}>*</sup>
            </Box>
            <DropDown
              placeHolder={"Select"}
              list={[0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18]}
              selectedValue={newGst}
              onChangeSelect={(value) => {
                setNewGst(value);
              }}
              style={{
                background: "#F2F4F7",
                selectedColor: "#667085",
              }}
            />
          </Box>

          {
            <Box width={'100%'} height={'49%'} overflow={'auto'}>
              <Box paddingX={"3rem"} backgroundColor={"#F9FAFB"}>
                <div style={{ width: "100%", height: "100%", color: "#515A6B", fontWeight: "600", fontSize: "16px", lineHeight: "26px" }}>
                  <div className={cssClasses.ThirdDivRow}>
                    <div>AV Value</div>
                    <div>₹{numberWithCommas(allotment?.old_unit_cost?.bsp)}</div>
                  </div>
                  {/* <Divider/> */}
                  <div className={cssClasses.ThirdDivRow}>
                    <div>Changed AV Value</div>
                    {/* <div>{allotment?.is_changeable_value ? (<span>₹{numberWithCommas(updatedUnitCost?.bsp)}</span>) : "NA"}</div> */}
                    <div>₹{numberWithCommas(newBspPrice)}</div>
                  </div>
                  {/* <Divider/> */}
                  <div className={cssClasses.ThirdDivRow}>
                    <div>SDR % </div>
                    {/* <div>({sdrPercentage}%) ₹{numberWithCommas(updatedUnitCost?.sdr)}</div> */}
                    <div>({sdrPercentage}%) ₹{numberWithCommas(calculateSdr())}</div>
                  </div>
                  {/* <Divider/> */}
                  <div className={cssClasses.ThirdDivRow}>
                    <div>Old GST %</div>
                    <div>({updatedUnitCost?.bsp < 4500000 ? 1 : 5}%) ₹{numberWithCommas(calculateGst())}</div>
                    {/* <div>({updatedUnitCost?.bsp < 4500000 ? 1 : 5}%) ₹{numberWithCommas(updatedUnitCost?.gst)}</div> */}
                    {/* <div>({updatedUnitCost?.bsp < 4500000 ? 1 : 5}%) ₹{numberWithCommas(updatedUnitCost?.gst)}</div> */}
                  </div>
                  <div className={cssClasses.ThirdDivRow}>
                    <div>New GST %</div>
                    <div>({newGst}%) ₹{numberWithCommas(calculateNewGst())}</div>
                    {/* <div>({updatedUnitCost?.bsp < 4500000 ? 1 : 5}%) ₹{numberWithCommas(updatedUnitCost?.gst)}</div> */}
                  </div>
                </div>
              </Box>
            </Box>}

          <Box className={cssClasses.FooterDiv}>
            <Box className={cssClasses.flexRow}>
              <Box width={'fit-Content'} ml={'auto'}>
                <Button
                  style={{
                    fontSize: '1.4rem',
                    lineHeight: '2rem',
                    color: '#344054',
                    backgroundColor: '#FFFFFF',
                    borderRadius: '0.8rem',
                  }}
                  padding={'0.85rem 2.6rem'}
                  btnName={'Cancel'}
                  clicked={handleClose}
                />
              </Box>

              <Box width={'fit-Content'}>
                <Button
                  style={{
                    fontSize: '1.6rem',
                    lineHeight: '2.4rem',
                    color: '#FFF',
                    backgroundColor: "#006AFF",
                    borderRadius: '0.8rem',
                  }}
                  padding={'0.65rem 3.2rem'}
                  //   disable={ChangeUnitStatusDetails.UnitStatus === ''}
                  btnName={"Confirm"}
                  clicked={() => {
                    handleSubmit(newGst);
                    setApproveConfirmationAlertToggle(true);
                    // handleClose();
                  }}
                />
              </Box>
            </Box>
          </Box>
        </Box>
      </Modal>
    </>
  )
}

export default GstPercentageChange;


function numberWithCommas(x) {
  return x?.toString().replace(/\B(?=(?:(\d\d)+(\d)(?!\d))+(?!\d))/g, ",");
}
